import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogCloseEvent } from '../../../const';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HelperMethods } from '../../common/helper-methods.service';
import { DtoUser, RegisterUser } from '../../../models/user-center.model';
import { ResetPasswordService } from '../../reset-password/reset-password.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-edit-profile-details',
  templateUrl: './edit-profile-details.component.html',
})
export class EditProfileDetailsComponent implements OnInit {
  
  profileForm: FormGroup = new FormGroup({
    newPassword: new FormControl('', [
      Validators.required,
      this.helperMethods.uppercaseValidator(),
      this.helperMethods.lowercaseValidator(),
      this.helperMethods.numberValidator(),
      this.helperMethods.SpecialCharValidator(),
      Validators.minLength(6),
    ]),
    confirmPassword: new FormControl('', [
      Validators.required,
      this.helperMethods.uppercaseValidator(),
      this.helperMethods.lowercaseValidator(),
      this.helperMethods.numberValidator(),
      this.helperMethods.SpecialCharValidator(),
      Validators.minLength(6),
    ])
  });
  url: string = '';
  showNewPassword = false;
  showConfirmPassword = false;
  
  constructor(@Optional() public dialogRef: MatDialogRef<EditProfileDetailsComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DtoUser,
              private helperMethods: HelperMethods,
              private resetPasswordService: ResetPasswordService,
              private toasterService: ToastrService,
              private router: Router
             ) {}

  ngOnInit(): void {
    if(this.data.profileUrl){
      this.url = this.data.profileUrl!
    }
  }

  toggleNewPasswordVisibility() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  cancel() {
    this.dialogRef.close({ event: MatDialogCloseEvent.CANCELLED });
  }

  resetPassword() {
    if (this.profileForm.controls['newPassword'].value != this.profileForm.controls['confirmPassword'].value) {
      this.toasterService.warning("Confirm password should be the same as the new password", "Incorrect");
      return;
    }

    let userDetails: RegisterUser = {
      emailId: this.data.email!,
      password: this.profileForm.controls['newPassword'].value,
      isPasswordForgotten: false
    }

    this.resetPasswordService.resetPassword(userDetails).subscribe((response: any)=>{
      if(response.succeeded){
        this.dialogRef.close({ event: MatDialogCloseEvent.SUCCESS });
        this.toasterService.success("Password updated successfully. Please log in with the updated credential", "Success");
        setTimeout(()=>{
          this.redirectToSignIn();
        }, 2000)
      }
      else {
        const errorMessages: string[] = response.responseData ? [response.responseData] :
          response.errors.map((error: any) => error.description);
        this.toasterService.error(errorMessages.join(','), 'Error');
      }
    }, (errorResponse: HttpErrorResponse) => {
      if(errorResponse.error){
        this.toasterService.error(errorResponse.error, "Error");
      }
    })
  }

  redirectToSignIn() {
    this.router.navigate(['/login']);
  }
}
